// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"b179596e","393":"eaddb2bc"}[chunkId] + ".chunk.js";
};